import React from "react";
import { motion, useAnimation } from "framer-motion";

function AnimatedCircle() {
  return (
    <motion.svg
      viewBox="0 0 120 120"
      className="w-28 h-28 mx-auto mb-7"
      initial={{ rotate: 0 }}
      animate={{ rotate: 360 }}
      transition={{
        repeat: Infinity,
        duration: 3.8,
        ease: "linear"
      }}
    >
      {/* Track */}
      <circle
        cx="60"
        cy="60"
        r="50"
        stroke="#dbeafe"
        strokeWidth="9"
        fill="none"
      />
      {/* Progress */}
      <motion.circle
        cx="60"
        cy="60"
        r="50"
        stroke="#2563eb"
        strokeWidth="7"
        fill="none"
        strokeLinecap="round"
        strokeDasharray={314}
        strokeDashoffset={60}
        initial={{ strokeDashoffset: 314 }}
        animate={{
          strokeDashoffset: [314, 60, 314]
        }}
        transition={{
          repeat: Infinity,
          duration: 3.8,
          ease: "easeInOut"
        }}
      />
      {/* Hourglass */}
      <motion.g
        initial={{ opacity: 0.9, y: 0 }}
        animate={{ y: [0, -3, 0], opacity: [0.9, 1, 0.9] }}
        transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
      >
        <rect
          x="52"
          y="36"
          width="16"
          height="48"
          rx="6"
          fill="#2563eb"
          opacity="0.08"
        />
        {/* Top triangle (sand) */}
        <polygon
          points="60,46 66,60 54,60"
          fill="#2563eb"
          opacity="0.16"
        />
        {/* Middle sand line */}
        <rect
          x="58.6"
          y="60"
          width="2.8"
          height="14"
          rx="1.4"
          fill="#2563eb"
          opacity="0.5"
        />
        {/* Lower triangle (sand pile) */}
        <polygon
          points="60,74 66,60 54,60"
          fill="#2563eb"
          opacity="0.35"
        />
        {/* Outline */}
        <rect
          x="52"
          y="36"
          width="16"
          height="48"
          rx="6"
          fill="none"
          stroke="#2563eb"
          strokeWidth="2"
        />
        {/* Top + Bottom lines */}
        <rect x="52" y="36" width="16" height="3" rx="1.5" fill="#2563eb" opacity="0.25" />
        <rect x="52" y="81" width="16" height="3" rx="1.5" fill="#2563eb" opacity="0.25" />
      </motion.g>
    </motion.svg>
  );
}

export default function Blog() {
  return (
    <div className="bg-gradient-to-tr from-blue-100 via-white to-blue-50 min-h-[80vh] flex items-center justify-center px-4 py-20">
      <motion.div
        initial={{ opacity: 0, y: 45, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, type: "spring" }}
        className="bg-white/80 rounded-3xl shadow-xl max-w-lg w-full flex flex-col items-center py-16 px-8"
      >
        <AnimatedCircle />

        <h1 className="text-3xl sm:text-4xl font-extrabold text-blue-900 mb-3 text-center tracking-tight">
        Coming Soon!
        </h1>
   
        <span className="text-blue-600 font-medium text-base tracking-wide">
          Stay tuned.
        </span>
      </motion.div>
    </div>
  );
}
